function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["eventId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { log } from "./logging";
import { posthog } from "./posthogUtil";
var EXPOSURE_ATTRIBUTE = 'data-tracking-exposure';
var CLICK_ATTRIBUTE = 'data-tracking-click';
var HOVER_ATTRIBUTE = 'data-tracking-hover';
var debounce = function debounce(func, delay) {
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(void 0, args);
    }, delay);
  };
};
var getDataFromElement = function getDataFromElement(element, type) {
  var _ref, _ref2;
  var defaultData = {
    eventId: 'defaultEventId'
  };
  var targetData = element.getAttribute(type) && element.getAttribute(type) !== 'true' ? element.getAttribute(type) : undefined;
  var clickData = element.getAttribute(CLICK_ATTRIBUTE) && element.getAttribute(CLICK_ATTRIBUTE) !== 'true' ? element.getAttribute(CLICK_ATTRIBUTE) : undefined;
  var exposureData = element.getAttribute(EXPOSURE_ATTRIBUTE) && element.getAttribute(EXPOSURE_ATTRIBUTE) !== 'true' ? element.getAttribute(EXPOSURE_ATTRIBUTE) : undefined;
  var hoverData = element.getAttribute(HOVER_ATTRIBUTE) && element.getAttribute(HOVER_ATTRIBUTE) !== 'true' ? element.getAttribute(HOVER_ATTRIBUTE) : undefined;
  var data = (_ref = (_ref2 = targetData !== null && targetData !== void 0 ? targetData : clickData) !== null && _ref2 !== void 0 ? _ref2 : exposureData) !== null && _ref !== void 0 ? _ref : hoverData;
  if (data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Error parsing tracking data:', error, 'The tracking data should be in JSON format,use trackingData() to generate.');
      return defaultData;
    }
  }
  console.error('No tracking data found for element:', element);
  return defaultData;
};
var intersectionObserver;
var mutationObserver;
var initalizeEventListeners = function initalizeEventListeners() {
  var fireEvent = function fireEvent(element, attribute, eventType) {
    var _posthog$capture;
    var eventData = getDataFromElement(element, attribute);
    var eventId = eventData.eventId,
      restData = _objectWithoutProperties(eventData, _excluded);
    log("Tracking ".concat(eventType, " event:"), _objectSpread(_objectSpread({}, eventData), {}, {
      trackingType: eventType
    }));
    (_posthog$capture = posthog.capture) === null || _posthog$capture === void 0 || _posthog$capture.call(posthog, eventId, _objectSpread(_objectSpread({}, restData), {}, {
      trackingType: eventType
    }));
  };
  var trackingElements = function trackingElements(attribute, eventType) {
    var debounceTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var debouceFireEvent = debounce(fireEvent, debounceTime);
    return function (event) {
      var target = event.target;

      // search for the closest element with the data-tracking-click attribute
      var element = target.closest("[".concat(attribute, "]"));
      if (element !== null && element !== void 0 && element.hasAttribute(attribute)) {
        // event.stopPropagation();
        debouceFireEvent(element, attribute, eventType);
      }
    };
  };

  // tracking click event
  document.body.addEventListener('click', trackingElements(CLICK_ATTRIBUTE, 'click'), true);
  // tracking hover event
  document.body.addEventListener('mouseenter', trackingElements(HOVER_ATTRIBUTE, 'mouseenter', 1000), true);

  // intersectionObserver for tracking exposure event
  intersectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var element = entry.target;
        if (element.hasAttribute(EXPOSURE_ATTRIBUTE)) {
          fireEvent(element, EXPOSURE_ATTRIBUTE, 'exposure');
          // avoid duplicate tracking
          intersectionObserver.unobserve(element);
        }
      }
    });
  }, {
    root: null,
    threshold: 0.5
  });

  // mutationObserver for tracking the attribute changes and new elements
  mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // tracking attribute changes
      var trackFlag = mutation.attributeName === EXPOSURE_ATTRIBUTE;
      if (mutation.type === 'attributes' && trackFlag) {
        var element = mutation.target;
        log('Tracking attribute changed:', element);
        intersectionObserver.observe(element);
      }

      // tracking new elements
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            var _element = node;

            // if the element has tracking attributes
            var _trackFlag = _element.hasAttribute(EXPOSURE_ATTRIBUTE);
            if (_trackFlag) {
              // log('New tracking element added:', element);

              intersectionObserver.observe(_element);
            }

            // traverse all child elements for sub-elements that have tracking attributes
            _element.querySelectorAll("[".concat(EXPOSURE_ATTRIBUTE, "]")).forEach(function (child) {
              // log('New tracking child element:', child);

              intersectionObserver.observe(child);
            });
          }
        });
      }
    });
  });
};
var isInitialized = false;
/**
 * #### NOTE: This function should be called only once when the page is loaded.
 *
 * #### Don't call this in react component.
 */
export function initTrackingObserver() {
  if (isInitialized) {
    console.warn('Tracking observer already initialized.');
    return;
  }
  isInitialized = true;
  log('Tracking observer initialized.');
  initalizeEventListeners();

  // initial tracking for existing elements
  document.querySelectorAll("[".concat(EXPOSURE_ATTRIBUTE, "]")).forEach(function (element) {
    log('Initial tracking exposure element:', element);
    intersectionObserver.observe(element);
  });
  mutationObserver.observe(document, {
    attributes: true,
    subtree: true,
    childList: true,
    attributeFilter: [CLICK_ATTRIBUTE, EXPOSURE_ATTRIBUTE, HOVER_ATTRIBUTE]
  });
}
export function destroyObserver() {
  var _mutationObserver, _intersectionObserver;
  log('Tracking observer destroyed.');
  (_mutationObserver = mutationObserver) === null || _mutationObserver === void 0 || _mutationObserver.disconnect();
  (_intersectionObserver = intersectionObserver) === null || _intersectionObserver === void 0 || _intersectionObserver.disconnect();
}